import { mergeAttributes, Node } from '@tiptap/core';
import { nanoid } from 'nanoid';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import AiImageView from '@/components/tiptap/views/AiImageView/AiImageView.vue';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    aiImage: {
      setAiImage: () => ReturnType;
    };
  }
}

export const AiImage = Node.create({
  name: 'aiImage',

  group: 'block',

  draggable: true,

  addOptions() {
    return {
      HTMLAttributes: {
        class: `node-${this.name}`,
      },
    };
  },

  addAttributes() {
    return {
      id: {
        default: undefined,
        parseHTML: (element) => element.getAttribute('data-id'),
        renderHTML: (attributes) => ({
          'data-id': attributes.id,
        }),
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `div.node-${this.name}`,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
  },

  addCommands() {
    return {
      setAiImage:
        () =>
        ({ chain, tr }) => {
          const { selection } = tr;
          const { $from } = selection;
          const currentNodeNextPos = $from.pos + $from.parent.childCount + 2;
          const targetEndPos = $from.after(1) || currentNodeNextPos;

          return chain()
            .focus()
            .insertContentAt(targetEndPos, {
              type: this.name,
              attrs: {
                id: nanoid(10),
              },
            })
            .run();
        },
    };
  },

  addNodeView() {
    return VueNodeViewRenderer(AiImageView);
  },
});

export default AiImage;
